import React, { useState } from "react";
import { Row, Col, Input, Label, FormFeedback, Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { createSkill } from "slices/Course/thunk"; // Your API thunk
import { AppDispatch } from "store";

interface SkillsFormProps {
  validation: any; // Formik instance
  courseId: number;
}

const SkillsForm: React.FC<SkillsFormProps> = ({ validation, courseId }) => {
  const [skillInput, setSkillInput] = useState("");
  const [saving, setSaving] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

const addSkill = async () => {
  const skillName = skillInput.trim();
  if (!skillName) return;

  try {
    setSaving(true);
    const payload = { course_id: courseId, skill_name: skillName };  // Update here
    await dispatch(createSkill(payload));

    const updatedSkills = [...(validation.values.skills ?? []), skillName];
    validation.setFieldValue("skills", updatedSkills);

    setSkillInput("");
    toast.success("Skill added successfully!");
  } catch (err) {
    console.error(err);
    toast.error("Failed to add skill");
  } finally {
    setSaving(false);
  }
};


  const deleteSkill = (index: number) => {
    const updatedSkills = (validation.values.skills ?? []).filter((_: any, i: number) => i !== index);
    validation.setFieldValue("skills", updatedSkills);
  };

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <Row className="g-3 mt-2">
        <Col md={12}>
          <Label>Add Skill *</Label>
          <div className="d-flex align-items-center border rounded p-1">
            <Input
              type="text"
              name="skill"
              placeholder="Write to add"
              value={skillInput}
              onChange={(e) => setSkillInput(e.target.value)}
              invalid={!!(validation.touched.skills && validation.errors.skills)}
              className="border-0"
              disabled={saving}
            />
            <Button color="success" disabled={!skillInput.trim() || saving} onClick={addSkill}>
              {saving ? <i className="fa fa-spinner fa-spin" /> : <i className="ri-add-line"></i>}
            </Button>
          </div>
          <FormFeedback>{validation.errors.skills}</FormFeedback>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md={12}>
          <div className="d-flex flex-wrap gap-2">
            {validation.values.skills?.map((s: string, index: number) => (
              <div
                key={index}
                className="position-relative px-3 py-1 bg-light border rounded-pill"
                style={{ minWidth: "100px" }}
              >
                {s}
                <i
                  className="ri-close-line text-danger"
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "-6px",
                    right: "-6px",
                    fontSize: "18px",
                    background: "white",
                    borderRadius: "50%",
                  }}
                  onClick={() => deleteSkill(index)}
                />
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </form>
  );
};

export default SkillsForm;
